import {
  SET_ACTION_PLAN,
  SET_ECAP,
  SET_ECAP_CLASSES_MATCHED,
  SET_ECAP_SUBJECT_DIFFICULTY,
  USER_LOGOUT_ECAP,
} from '../actionTypes';

const getInitialState = () => ({
  plan: {
    career_path: '',
    institution: '',
    institution_costs: '',
    application_deadline: null,
    application_complete: false,
    financial_aid: [],
    Extracurricular: [],
    Work: [],
    Volunteer: [],
    Achievement: [],
    fall_freshman_gpa: '',
    spring_freshman_gpa: '',
    fall_sophmore_gpa: '',
    spring_sophmore_gpa: '',
    fall_junior_gpa: '',
    spring_junior_gpa: '',
    fall_senior_gpa: '',
    spring_senior_gpa: '',
    total_GPA: '',
    psat: '',
    sat: '',
    act: '',
    class_rank: '',
    student_number: '',
    counselor_name: '',
    parent_name: '',
    counselor_email: '',
    parent_email: '',
    classes_matched: {},
  },
  actionPlan: {
    action_plan_career_id: null,
  },
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SET_ECAP: {
      const { plan } = action.payload;

      return {
        ...state,
        plan,
      };
    }

    case SET_ECAP_CLASSES_MATCHED: {
      const { classes_matched } = action.payload;

      return {
        ...state,
        plan: {
          ...state.plan,
          classes_matched,
        },
      };
    }

    case SET_ECAP_SUBJECT_DIFFICULTY: {
      const { subjectDifficulty } = action.payload;

      return {
        ...state,
        subjectDifficulty,
      };
    }

    case SET_ACTION_PLAN: {
      const { actionPlan } = action.payload;

      return {
        ...state,
        actionPlan,
      };
    }

    case USER_LOGOUT_ECAP: {
      return getInitialState();
    }

    default:
      return state;
  }
}
